import {
  EditableRow,
  ListItemButton,
  SettingsCard,
  SettingsListItem,
  SettingsRow,
  SettingsSection,
} from './settings-ui';

/**
 * Settings › Security & auth (SCRUM-460): the authentication-policy card (MFA is
 * enforced by the bank's IdP — BankIQ has no own 2FA layer; session timeout) and
 * the active-sessions card. Ports `renderSettingsSectionSecurity`.
 *
 * DEMO-ERA SCOPE: session timeout and the active-sessions list are presentation
 * only in this iteration — there is no session-store backend. The MFA note is
 * accurate (SCRUM-102 delegates MFA to the IdP). Session-timeout persistence and
 * real session revocation are future work; the values below match the prototype.
 */
export function SecuritySection() {
  return (
    <SettingsSection>
      <SettingsCard title="Authentication policy">
        <SettingsRow label="Multi-factor authentication">
          <span className="text-text-3 text-[0.8125rem]">
            Enforced by your identity provider at sign-in
          </span>
        </SettingsRow>
        <EditableRow
          label="Session timeout"
          help="Inactivity period before re-authentication"
          value="30 minutes"
          onSave={() => {
            /* Session-timeout persistence is future work (no session-policy backend yet). */
          }}
        />
      </SettingsCard>

      <SettingsCard title="Active sessions">
        <SettingsListItem
          name="Carol Whitfield · Chrome / macOS"
          sub="Winchester, VA · Last activity 4 min ago"
          action={<ListItemButton danger>End session</ListItemButton>}
        />
        <SettingsListItem
          name="Marcus Hale · Safari / iPhone"
          sub="Strasburg, VA · Last activity 1 hour ago"
          action={<ListItemButton danger>End session</ListItemButton>}
        />
      </SettingsCard>
    </SettingsSection>
  );
}
